
// AuthContext.js
import { createContext, useContext, useState, useEffect, useRef, useCallback } from 'react';

import {    
  sessionService, 
} from '../components/ComponentsLibrary';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isTokenValidated, setIsTokenValidated] = useState(false);

  const [isSiteSelected, setIsSiteSelected] = useState(() => {
    // Initialize from sessionStorage synchronously
    const storedAuth =  sessionService.getUser() ? sessionService.getUser().isSiteSelected : false;
    return storedAuth === 'true';
  });

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const propsForProvider = {
    isTokenValidated,
    setIsTokenValidated,
    isSiteSelected,
    setIsSiteSelected,
    isAuthenticated,
    setIsAuthenticated,
  };

  useEffect(() => {
    // Check auth status after reload
    const checkAuth = () => {
      const authStatus = sessionService.getUser() ? sessionService.getUser().isSiteSelected : false;
      setIsSiteSelected(authStatus);
    };
    checkAuth();
  }, [])

  return (
    <AuthContext.Provider value={propsForProvider}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  return useContext(AuthContext);
}